import {
  EQUIPE_TAB_CALENDARIO,
  EQUIPE_TAB_PROFISSIONAIS,
} from "@/shared/components/equipe-obra/equipe-obra.constants";

export const EQUIPE_DIALOG_TITLE = "Definir Equipe de Obra";
/** Título do mesmo modal na edição da equipe já gravada (HU 2051). */
export const EQUIPE_EDIT_DIALOG_TITLE = "Editar Equipe de Obra";
export const EQUIPE_HEADLINE = "Adicione os profissionais";

export const EQUIPE_CARD_OBRA = "Obra";
export const EQUIPE_CARD_INICIO = "Início da Obra";
export const EQUIPE_CARD_FIM = "Fim da Obra";

export const EQUIPE_NO_ROWS_MESSAGE = "Adicione ao menos um profissional à equipe.";

// Equipe já gravada (HU 2051): edição de período no próprio modal
export const EQUIPE_SUCCESS_SUMMARY = "Sucesso";
export const EQUIPE_SUCCESS_DETAIL = "Alterações salvas.";
export const EQUIPE_GRAVADA_EMPTY_MESSAGE = "Esta obra ainda não possui profissionais na equipe.";
export const EQUIPE_GRAVADA_LOADING = "Carregando equipe...";
export const EQUIPE_GRAVADA_ERROR_TITLE = "Não foi possível carregar a equipe da obra.";
export const EQUIPE_GRAVADA_FORBIDDEN_TITLE = "Acesso não autorizado";
export const EQUIPE_GRAVADA_RETRY_LABEL = "Tentar novamente";

// Salvar com verificações (HU 2059: analisar alocação da equipe de obra)

export const VERIFICACAO_ERROR_MESSAGE =
  "Não foi possível verificar a disponibilidade do profissional.";

export const ALOCACAO_JUSTIFICADA_TOAST = "Alocação confirmada com a justificativa registrada.";
export const PROFISSIONAL_JUSTIFICADO_TOAST =
  "Profissional adicionado com a justificativa registrada.";

export const EQUIPE_CALENDARIO_LOADING_LABEL = "Carregando papéis e profissionais...";

export const EQUIPE_TABS = [
  { id: "profissionais", label: EQUIPE_TAB_PROFISSIONAIS },
  { id: "calendario", label: EQUIPE_TAB_CALENDARIO },
] as const;
